<div class="input-fake-container">
  <ion-label
    class="input-fake-label"
    position="stacked"
  >
    {{ label }}
  </ion-label>
  <div class="input-fake-content">
    {{ value }}
  </div>
</div>
